import { WeightKilogramIcon } from './WeightKilogramIcon';

/**
 * author: Austin Andrews
 * id 5EDFF36D-4C8E-4B8D-BE3F-76C27DB804DF
 * name weight-kilogram
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weight-kilogram.svg
 * tags
 */
export const WeightKgIcon = WeightKilogramIcon;
export default WeightKgIcon